import { render, staticRenderFns } from "./discussion_reply_placeholder.vue?vue&type=template&id=34a3f46e&"
import script from "./discussion_reply_placeholder.vue?vue&type=script&lang=js&"
export * from "./discussion_reply_placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports